export const HOST_PAGE_EVENT_NAMES = {
  ABANDON_CART_NUDGE: 'abandon_cart_nudge',
  EG3_SDK_LOAD: 'eg3_sdk_load',
  STUDIO_GRID_AMOUNT_CHANGE: 'studio_grid_amount_change',
  STUDIO_GRID_CURRENCY_CHANGE: 'studio_grid_currency_change',
  STUDIO_GRID_FREQUENCY_CHANGE: 'studio_grid_frequency_change',
  STUDIO_GRID_INTERACTION: 'studio_grid_interaction',
  STUDIO_GRID_PRIMARY_CTA_CLICK: 'studio_grid_primary_cta_click',
  STUDIO_GRID_VIEWED: 'studio_grid_viewed',
} as const

export const HOST_PAGE_MPARTICLE_EVENT_TYPES = {
  LOCATION: 'Location',
  MEDIA: 'Media',
  NAVIGATION: 'Navigation',
  OTHER: 'Other',
  SEARCH: 'Search',
  SOCIAL: 'Social',
  TRANSACTION: 'Transaction',
  UNKNOWN: 'Unknown',
  USER_CONTENT: 'UserContent',
  USER_PREFERENCE: 'UserPreference',
} as const

export const HOST_PAGE_MPARTICLE_SURFACE = 'embedded-sdk'

export type HostPageEventName = (typeof HOST_PAGE_EVENT_NAMES)[keyof typeof HOST_PAGE_EVENT_NAMES]
export type HostPageMParticleEventType =
  (typeof HOST_PAGE_MPARTICLE_EVENT_TYPES)[keyof typeof HOST_PAGE_MPARTICLE_EVENT_TYPES]

export type HostPageEventSource = 'abandon-cart-nudge' | 'inline-donation-grid'

export interface HostPageEventData {
  [key: string]: unknown
}

export interface HostPageMParticleEventInfo {
  [key: string]: boolean | null | number | string | undefined
}

interface HostPageMParticleInstructionBase {
  eventInfo?: HostPageMParticleEventInfo
  eventName: string
  eventType: HostPageMParticleEventType
}

export interface HostPageMParticleEventInstruction extends HostPageMParticleInstructionBase {
  tracker: 'event'
}

export interface HostPageMParticleFunnelInstruction extends HostPageMParticleInstructionBase {
  tracker: 'funnel'
}

export interface HostPageMParticleUIElementInstruction extends HostPageMParticleInstructionBase {
  tracker: 'ui-element'
}

export type HostPageMParticleInstruction =
  | HostPageMParticleEventInstruction
  | HostPageMParticleFunnelInstruction
  | HostPageMParticleUIElementInstruction

export interface HostPageEventInput {
  campaignId: string
  componentId?: string
  data: HostPageEventData
  mparticle?: HostPageMParticleInstruction
  name: HostPageEventName
  source: HostPageEventSource
}

export interface QueuedHostPageEvent extends HostPageEventInput {
  capturedAt: number
  id: string
  sequence: number
}
